import React, { createContext, useContext, useState, ReactNode } from 'react';

interface SystemErrorContextType {
  isSystemUnavailable: boolean;
  setSystemUnavailable: (unavailable: boolean) => void;
  networkError: string | null;
  setNetworkError: (error: string | null) => void;
}

const SystemErrorContext = createContext<SystemErrorContextType | null>(null);

export const SystemErrorProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isSystemUnavailable, setIsSystemUnavailable] = useState(false);
  const [networkError, setNetworkError] = useState<string | null>(null);

  const setSystemUnavailable = (unavailable: boolean) => {
    setIsSystemUnavailable(unavailable);
    if (!unavailable) {
      setNetworkError(null);
    }
  };

  return (
    <SystemErrorContext.Provider value={{
      isSystemUnavailable,
      setSystemUnavailable,
      networkError,
      setNetworkError
    }}>
      {children}
    </SystemErrorContext.Provider>
  );
};

export const useSystemError = (): SystemErrorContextType => {
  const context = useContext(SystemErrorContext);
  if (!context) {
    throw new Error('useSystemError must be used within SystemErrorProvider');
  }
  return context;
};